<ol class="breadcrumb page-breadcrumb" *transloco="let translated" [ngClass]="marginBottom">
  @for (item of this.breadcumbs; track $index) { @if (this.enableLanguage) {
  <li class="breadcrumb-item" [class.active]="$index == this.activeIndex">
    <a *ngIf="item.url !== ''" [routerLink]="item.url">{{ translated(item.label) }}</a>
    <span *ngIf="item.url === ''">{{ translated(item.label) }}</span>
  </li>
  } @else {
  <li class="breadcrumb-item" [class.active]="$index == this.activeIndex">
    <a *ngIf="item.url !== ''" [routerLink]="item.url">{{ item.label }}</a>
    <span *ngIf="item.url === ''">{{ item.label }}</span>
  </li>
  } } @if (this.enableDisplayDate) {
  <li class="position-absolute pos-top pos-right d-none d-sm-block">
    <span class="js-get-date">
      {{ this.displayDay }}
    </span>
  </li>
  }
</ol>
